import { Box, Typography, useMediaQuery, Menu, MenuItem } from '@mui/material';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { useHasPermission } from '../../../hooks/useHasPermission';
import { UpdateRoleName } from '../editRole/updateRoleName';
import { DeleteRecord } from '../../deleteRecord';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { useListBackNavigation } from '../../../hooks/listNavigation';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import Iconify from '../../Iconify';
import axios from 'axios';
import '../../../css/roles/roleDetailsHeader.css';

const RoleDetailsHeader = () => {

    const { t } = useTranslation();
    const { goBack, goToList } = useListBackNavigation('/dashboard/roles');
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    const roleDetailsData = useSelector((state) => state.RoleDetailsData);

    const hasMachineUpdatePermission = useHasPermission('role_update');
    const hasMachineDeletePermission = useHasPermission('role_delete');

    const [errMsg, setErrMsg] = useState('');
    const [modifyName, setModifyName] = useState(false);
    const [deleteRole, setDeleteRole] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const openActionMenu = Boolean(anchorEl);

    const handleDeleteRole = async () => {
        try {
            const response = await axios.delete(`role/${roleDetailsData.id}`);
            if (response.status === 200 || response.status === 201) {
                setDeleteRole(false);
                goToList();
                setErrMsg('');
            }
        } catch (error) {
            setErrMsg(error.message || "Erreur lors de la suppression du rôle");
            console.error('Error deleting role:', error);
            CustomErrorLogger(error, "Delete Role");
        }
    }

    const handleOpenActionMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseActionMenu = () => {
        setAnchorEl(null);
    };

    const handleGoBack = goBack;

    return (
        <Box className="roleDetailsHeader_mainBox">
            <Box className="roleDetailsHeader_firstPart">
                <Iconify className='roleDetailsHeader_back_icon' icon={"material-symbols:arrow-back"} onClick={handleGoBack} />
                <Typography className="roleDetailsHeader_title">{roleDetailsData?.name}</Typography>
                {hasMachineUpdatePermission && <Iconify className='roleDetailsHeader_edit_icon' icon={"ic:outline-edit"} onClick={() => setModifyName(true)} />}
                {roleDetailsData?.description}
            </Box>
            <Box className="roleDetailsHeader_secondPart">
                {isDesktop && hasMachineDeletePermission &&
                    <Box className="roleDetailsHeader_action_box" onClick={() => setDeleteRole(true)}>
                        <Iconify className='roleDetailsHeader_delete_icon' icon={"ic:outline-delete"} />
                        <Typography className="roleDetailsHeader_delete_title">{t('Supprimer')}</Typography>
                    </Box>
                }
                {!isDesktop && <Iconify
                    className='roleDetailsHeader_dots_icon'
                    icon={"vaadin:ellipsis-dots-v"}
                    id="userPageActionMenuIcom"
                    aria-controls={openActionMenu ? 'long-menu' : undefined}
                    aria-expanded={openActionMenu ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={handleOpenActionMenu}
                />}
                <Menu
                    id="usersePageActionMenu"
                    MenuListProps="usersPageActionMenuIcom"
                    open={openActionMenu}
                    anchorEl={anchorEl}
                    onClose={handleCloseActionMenu}
                    onClick={handleCloseActionMenu}
                    slotProps={{ paper: { style: { width: '30ch', backgroundColor: '#fffff' } } }}
                >
                    {!isDesktop && hasMachineDeletePermission &&
                        <MenuItem className='roleDetailsHeader_menuItem' onClick={() => setDeleteRole(true)}>
                            <Iconify className='roleDetailsHeader_delete_icon' icon={"ic:outline-delete"} />
                            <Typography className="roleDetailsHeader_delete_title">{t('Supprimer')}</Typography>
                        </MenuItem>
                    }
                </Menu>
            </Box>

            {modifyName &&
                <UpdateRoleName
                    modifyName={modifyName}
                    setModifyName={setModifyName}
                />
            }
            {deleteRole &&
                <DeleteRecord
                    errMsg={errMsg}
                    setErrMsg={setErrMsg}
                    openDelete={deleteRole}
                    setOpenDelete={setDeleteRole}
                    handleDelete={handleDeleteRole}
                    title="Êtes-vous sûr de vouloir supprimer ce rôle ?"
                />
            }
        </Box>
    );
}

export default RoleDetailsHeader;